
import Title from "../../components/Title";
import { useEffect, useState } from "react";
import { Dropdown, Spinner } from "react-bootstrap";
import listaMotivosCancelacion from "../../services/adp/motivo_cancelacion/list";
import eliminarMotivoCancelacion from "../../services/adp/motivo_cancelacion/delete";
import { useCallback } from "react";
import { ModalMotivosCancelacion } from "../../components/Modals/MotivosCancelacion";
import { useAuth } from "../../hooks/auth";

export default function MotivosCancelacion(props) {
    const { token: TOKEN } = useAuth();
    const [motivoCancelacion, setMotivoCancelacionList] = useState([]);

    const [ver_modal, setAbrirModal] = useState(false);
    const [idSeleccionado, setIdSeleccionado] = useState(0);
    const [loading, setLoading] = useState(true);

    const obtenerListadoMotivos = useCallback(() => {
        setLoading(true);
        listaMotivosCancelacion({
            token: TOKEN, callbacks: response => {
                setMotivoCancelacionList(response.resultados ?? [])
                setLoading(false);
            }
        });
    }, [TOKEN]);

    useEffect(() => {
        obtenerListadoMotivos();
    }, [obtenerListadoMotivos]);


    async function eliminarMotivo(id) {
        eliminarMotivoCancelacion({
            id: id, token: TOKEN, callbacks: response => {
                if (response.estado > 0) {
                    obtenerListadoMotivos();
                }
            }
        });
    }


    function abrirModal(id) {
        setIdSeleccionado(id);
        setAbrirModal(true);
    }

    async function cerrarModal() {
        setAbrirModal(false);
        setIdSeleccionado(0);
    }


    return (
        <main>
            <div className="container-fluid ps-0">
                <div className="glassDatos">
                    <div className="pb-4 d-flex align-items-center justify-content-between">
                        <Title title="Motivos de cancelacion" class="titlegray" />
                        <ModalMotivosCancelacion
                            TOKEN={TOKEN}
                            ver_modal={ver_modal}
                            setAbrirModal={setAbrirModal}
                            cerrarModal={cerrarModal}
                            idSeleccionado={idSeleccionado}
                            setIdSeleccionado={setIdSeleccionado}
                            obtenerListadoMotivos={obtenerListadoMotivos}
                        />
                    </div>
                    {
                        loading &&
                        <Spinner animation="border" role="status">
                            <span className="visually-hidden">Cargando...</span>
                        </Spinner>
                    }
                    {
                        !loading &&
                        <table className="table table-stripped table-hover">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Nombre</th>
                                    <th>Descripcion</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    motivoCancelacion.map((item) => {
                                        return (
                                            <tr key={item.id}>
                                                <td>{item.id}</td>
                                                <td>{item.name}</td>
                                                <td>{item.description}</td>
                                                <td>
                                                    <Dropdown className="d-flex justify-content-center">
                                                        <Dropdown.Toggle variant="none" id="dropdown-basic" className="btnDropDownTables"></Dropdown.Toggle>

                                                        <Dropdown.Menu>
                                                            <Dropdown.Item onClick={() => abrirModal(item.id)}>Editar</Dropdown.Item>
                                                            <Dropdown.Item onClick={() => eliminarMotivo(item.id)}>Eliminar</Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    }
                </div>
            </div>
        </main>
    )
}